import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotificationService } from 'src/app/shared/isolutions-ui/feedback/notifications/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseApiService } from './base-api.service';
import { SpinnerService } from './spinner.service';
import { ApiResponse } from '../models/api-response.model';
import { UserUpdate } from '../models/user.model';
import { SelectContractorRequest } from '../models/contractor.model';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseApiService {
  constructor(
    http: HttpClient,
    notify: NotificationService,
    translate: TranslateService,
    spinner: SpinnerService,
  ) {
    super(http, notify, translate, spinner);
  }

  getUsers(): Observable<ApiResponse<any[]>> {
    return this.get<any[]>('users');
  }

  getUserById(id: number): Observable<ApiResponse<any>> {
    return this.get<any>(`User/${id}`);
  }

  updateUser(id: number, data: UserUpdate): Observable<ApiResponse<any>> {
    return this.put<any>(`User/${id}`, data);
  }

  selectContractor(request: SelectContractorRequest): Observable<ApiResponse<any>> {
    return this.put<any>('User/select-contractor', request);
  }

  deleteUser(id: number): Observable<ApiResponse<any>> {
    return this.delete<any>(`User/${id}`);
  }
}
